const stateProperty = {
  nameState: "State global propertys",
  property: null,
  properties: [],

  template: {
    type: "",
    operation_mode: "single",

    attach_listing_id: null,
    listing_name: "",
    paisName: null,
    pais: null,
    whatsapp: true,
    telegram: false,
    sms: false,
    email: false,

    logo: null,   // se deja por compatibilidad, pero ya no se usa
    value: "",    // se deja por compatibilidad, pero ya no se usa

    content: "",
    contentEN: "",
    contentAR: "",
    msgWelcome: "",
    msgWelcomeEN: "",
    msgWelcomeAR: "",
    id: null,
    nombre: null,
    internalName: null,
    requireSelfie: false,
    requireDocumento: false,
    address: null,
    city: null,
    zipCode: null,

    latitude: null,
    longitude: null,
    placeId: null,

    guests: 1,
    bedrooms: 1,
    bathrooms: 1,
    services: [],
    priceNight: null,
    currency: "USD",
    description: "",

    roomTypesName: "",
    roomTypesOcc_adults: 1,
    roomTypesOcc_children: 0,
    roomTypesOcc_infants: 0,
    roomCode: "",
    roomName: "",
  },

  validations: {
    step1: false,
    step2: false,
    step3: false,
    step4: false,
    step5: false,
    step6: true,
    step7: true,
  },
};

export default stateProperty;
